import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import sanityClient from '../../sanityClient';
import { Link } from "react-router-dom";
import emailjs from "emailjs-com";
import { useSourceUrl } from "../../context/SourceUrlContext";

export default function GetInTouch({ isServiceLandingPage, isMainLandingPage }) {
  const sourceUrlObject = useSourceUrl(); // Assuming this returns an object
  const sourceUrl = sourceUrlObject?.sourceUrl || "";
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    // location: '',
    // carpetArea: '',
    budget: '',
    otherInfo: '',
    queryPage: isServiceLandingPage
      ? "luxury-interior-design-company"
      : isMainLandingPage
        ? "interior-designer-in-gurgaon" : "",
    sourceUrl,
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const validate = () => {
    const errors = {};

    // Validate Name
    if (!formData.fullName.match(/^[A-Za-z\s]+$/)) {
      errors.fullName = 'Name must only contain letters and spaces.';
    }

    // Validate Email
    if (!formData.email.match(/^\S+@\S+\.\S+$/)) {
      errors.email = 'Enter a valid email address.';
    }

    // Validate Mobile Number
    if (!formData.phoneNumber.match(/^\d{10}$/)) {
      errors.phoneNumber = 'Mobile number must be exactly 10 digits.';
    }

    // Validate Budget
    if (!formData.budget.trim()) {
      errors.budget = "Budget is required.";
    }
    // else if (!/^\d+$/.test(formData.budget)) {
    //   errors.budget = "Budget must be a valid number.";
    // } else if (parseInt(formData.budget, 10) <= 29) {
    //   errors.budget = "Budget must be greater than 30 Lakhs.";
    // }

    // Validate Other Info
    if (!formData.otherInfo.trim()) {
      errors.otherInfo = "Other information is required.";
    }

    // Validate Location (Required)
    // if (!formData.location.trim()) {
    //   errors.location = 'Location is required.';
    // }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setIsSubmitting(true);

    try {
      // Send data to Sanity
      const sanityResponse = await sanityClient.create({
        _type: 'contactUs',
        fullName: formData.fullName,
        phoneNumber: formData.phoneNumber,
        email: formData.email,
        budget: formData.budget,
        otherInfo: formData.otherInfo,
        queryPage: formData.queryPage,
        sourceUrl: formData.sourceUrl,
        submittedAt: new Date().toISOString(),
      });

      console.log('Sanity submission successful:', sanityResponse);

      // Send data to EmailJS
      const emailResponse = await emailjs.send(
        'service_cidvdzr',
        'template_xtw8kxp',
        {
          fullName: formData.fullName,
          phoneNumber: formData.phoneNumber,
          email: formData.email,
          budget: formData.budget,
          queryPage: formData.queryPage,
          otherInfo: formData.otherInfo,
          sourceUrl: formData.sourceUrl,
        },
        '8kmH2H-c7ywe6imZy'
      );

      console.log('EmailJS submission successful:', emailResponse);

      // Call the refresh token API
      // const refreshResponse = await fetch('https://api.theinteria.com/api/refresh-token', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     refresh_token: '1000.4eb9d9bbc7303ed2643c4783d3170839.9a8c3735d2df30313d7249c40ed4d45b',
      //   }),
      // });

      // const refreshData = await refreshResponse.json();
      // console.log('Refresh token API response:', refreshData);

      // const accessToken = refreshData.access_token;
      // localStorage.setItem('zohoAccessToken', accessToken);

      // window.zohoAccessToken = accessToken;
      // console.log("accessToken", accessToken);

      // const zohoLeadData = {
      //   // Assuming fullName is valid
      //   Last_Name: formData.fullName, // Extracting the last name
      //   Mobile: formData.phoneNumber, // Ensure phoneNumber is valid
      //   Email: formData.email, // Ensure email is valid
      //   Budget: formData.budget, // Map correctly to Budget
      //   Description: formData.otherInfo, // Additional information
      //   queryPage: formData.queryPage,
      //   sourceUrl: formData.sourceUrl, // Set lead page
      //   Created_At: new Date().toISOString(), // Set created date in ISO format
      // };

      // console.log("zohoLeadData", zohoLeadData);

      // try {
      //   const createLead = await fetch("https://api.theinteria.com/api/create-lead", {
      //     method: "POST",
      //     headers: {
      //       Authorization: accessToken, // Replace with a valid access token
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify(zohoLeadData),
      //   });

      //   const createData = await createLead.json();
      //   console.log("final response:", createData);
      // } catch (error) {
      //   console.error("Error creating lead:", error);
      // }

      const TeleforceData = {
        name: formData.fullName,
        mobile: formData.phoneNumber,
        email: formData.email,
        // source: formData.queryPage,
        source: "Footer section form",
        usergroupid: "GRP1iof8om0h4b6g0",
        segmentid: "SEGgkgi9g2gvgu051746180629686",
        otherparams: [
          { "meta_key": "budget", "meta_value": formData.budget },
          { "meta_key": "other information", "meta_value": formData.otherInfo },
        ]
      }

      try {
        const createLead = await fetch("https://platformapi.teleforce.in/api/v1/api/createlead/517848", {
          method: "POST",
          headers: {
            'Cookie': 'AWSALBTG=DHOO6TszEpJ9ALtpdQtbfMsaiNnbdGzqKfPlFBXTVSRDW9nKXZPglL/14LUx0sjOxzKoawsQ/dt426o0hrbCrY8EZrKRFU9EsYFXAQxZ0xwDLAhwJyh7zHBhH/nHTZTvyCascq+L4Ri7X+QrI3rDOpJQsz5mcP0B7KS/dLuo+GdUK/9EsDs=; AWSALBTGCORS=DHOO6TszEpJ9ALtpdQtbfMsaiNnbdGzqKfPlFBXTVSRDW9nKXZPglL/14LUx0sjOxzKoawsQ/dt426o0hrbCrY8EZrKRFU9EsYFXAQxZ0xwDLAhwJyh7zHBhH/nHTZTvyCascq+L4Ri7X+QrI3rDOpJQsz5mcP0B7KS/dLuo+GdUK/9EsDs=',

            "Content-Type": "application/json",
          },
          body: JSON.stringify(TeleforceData)
        });
      } catch (error) {
        console.error("Error creating lead:", error);
      }

      // Reset form and navigate to thank you page
      setFormData({
        fullName: '',
        phoneNumber: '',
        email: '',
        budget: '',
        otherInfo: '',
        queryPage: '',
        sourceUrl: '',
      });
      navigate("/thankyou");
    } catch (err) {
      if (err.response) {
        console.error('API response error:', err.response.data);
      } else if (err.message) {
        console.error('Error message:', err.message);
      } else {
        console.error('Unknown error:', err);
      }

      setErrors({
        general: 'Error submitting the form. Please check your inputs and try again.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="get-touch">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-md-6">
            <div className="gettouch-text">
              <h4 className="heading">get in touch</h4>
              <p>
                <img src="/assets/home/star.png" alt="Star" width={"100%"} height={"100%"} /> Contact us
              </p>
            </div>
          </div>

          <div className="col-lg-5 col-md-6">
            <div
              className="gettouch-form wow animate__animated animate__slideInRight"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
            >
              {/* {(isServiceLandingPage||isMainLandingPage) ? (<p className='landform-head'>For Project enquiries, fill out the form, or contact us at <Link to={"tel:+917042112226"}>+91 70421 12226</Link>.</p>):"" }  */}
              {(isServiceLandingPage || isMainLandingPage) ? (
                <p className="landform-head">
                  For Project enquiries, fill out the form, or contact us at{" "}
                  <Link to={"tel:+917042112226"}>+91 70421 12226</Link>.
                </p>
              ) : ("")}
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 form-feild">
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Full Name*"
                      className="form-control"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                    />
                    {errors.fullName && <p className="error-text">{errors.fullName}</p>}
                  </div>

                  <div className="col-lg-6 form-feild">
                    <input
                      type="text"
                      name="phoneNumber"
                      placeholder="Phone Number*"
                      className="form-control"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                    />
                    {errors.phoneNumber && <p className="error-text">{errors.phoneNumber}</p>}
                  </div>

                  <div className="col-lg-6 form-feild">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email ID*"
                      className="form-control"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    {errors.email && <p className="error-text">{errors.email}</p>}
                  </div>

                  <div className="col-lg-6 form-feild">
                    {/* <input
                      type="text"
                      name="budget"
                      placeholder="Budget Minimum 30 (In Lakhs)"
                      className="form-control"
                      value={formData.budget}
                      onChange={handleChange}
                      required
                    /> */}
                    <select name="budget" className="form-control" value={formData.budget || ""} onChange={handleChange} required>
                      <option value="" disabled hidden> Choose Budget*</option>
                      <option value="30 Lakhs to 50 Lakhs"> 30 Lakhs to 50 Lakhs</option>
                      <option value="51 Lakhs to 1 Cr.">51 Lakhs to 1 Cr.</option>
                      <option value="1 Cr. to 2 Cr.">1 Cr. to 2 Cr.</option>
                      <option value="More Than 2 Cr.">More Than 2 Cr.</option>
                    </select>
                    {errors.budget && <p className="error-text">{errors.budget}</p>}
                  </div>

                  <div className="col-lg-12 form-feild">
                    <input
                      type="text"
                      name="otherInfo"
                      placeholder="Any Other Information"
                      className="form-control"
                      value={formData.otherInfo}
                      onChange={handleChange}
                      required
                    />
                    {errors.otherInfo && <p className="error-text">{errors.otherInfo}</p>}
                  </div>

                  <div className="col-lg-12 text-center">
                    <button className="default-btn" type="submit" disabled={isSubmitting}>
                      Contact Us<span></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
